/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddOrUpdateFinancialChannelRequest,
  AddOrUpdateFinancialGroupRequest,
  AddOrUpdateTaskBoxRequest,
  AddressPersonRequest,
  ApiError,
  CreateAvailableParking,
  CreateTransportStop,
  DoctorInformation,
  DoctorSlug,
  FinancialChannelLightResponse,
  FinancialChannelResponse,
  FinancialGroupLightResponse,
  FinancialGroupResponse,
  HealthPro,
  InstitutePreferencesRequest,
  InstitutePreferencesResponse,
  PaginatedUserAppointmentsResponse,
  ParkingAvailable,
  PersonWithRoleResponse,
  PlanningByPeriodResponse,
  PlanningGeneralSettingsResponse,
  TaskBoxLightResponse,
  TaskBoxPersonsLightResponse,
  TransportStop,
  UpdateAddressPersonResponse,
  UpdateDoctorSlug,
  UpdateDoctorTitleRequest,
  UpdateEmailPwrRequest,
  UpdateEmailPwrResponse,
  UpdatePersonPermissionRequest,
  UpdatePhonePwrRequest,
  UpdatePhonePwrResponse,
  UpdateTaskboxPermissionRequest,
} from '../models/index';
import {
    AddOrUpdateFinancialChannelRequestFromJSON,
    AddOrUpdateFinancialChannelRequestToJSON,
    AddOrUpdateFinancialGroupRequestFromJSON,
    AddOrUpdateFinancialGroupRequestToJSON,
    AddOrUpdateTaskBoxRequestFromJSON,
    AddOrUpdateTaskBoxRequestToJSON,
    AddressPersonRequestFromJSON,
    AddressPersonRequestToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateAvailableParkingFromJSON,
    CreateAvailableParkingToJSON,
    CreateTransportStopFromJSON,
    CreateTransportStopToJSON,
    DoctorInformationFromJSON,
    DoctorInformationToJSON,
    DoctorSlugFromJSON,
    DoctorSlugToJSON,
    FinancialChannelLightResponseFromJSON,
    FinancialChannelLightResponseToJSON,
    FinancialChannelResponseFromJSON,
    FinancialChannelResponseToJSON,
    FinancialGroupLightResponseFromJSON,
    FinancialGroupLightResponseToJSON,
    FinancialGroupResponseFromJSON,
    FinancialGroupResponseToJSON,
    HealthProFromJSON,
    HealthProToJSON,
    InstitutePreferencesRequestFromJSON,
    InstitutePreferencesRequestToJSON,
    InstitutePreferencesResponseFromJSON,
    InstitutePreferencesResponseToJSON,
    PaginatedUserAppointmentsResponseFromJSON,
    PaginatedUserAppointmentsResponseToJSON,
    ParkingAvailableFromJSON,
    ParkingAvailableToJSON,
    PersonWithRoleResponseFromJSON,
    PersonWithRoleResponseToJSON,
    PlanningByPeriodResponseFromJSON,
    PlanningByPeriodResponseToJSON,
    PlanningGeneralSettingsResponseFromJSON,
    PlanningGeneralSettingsResponseToJSON,
    TaskBoxLightResponseFromJSON,
    TaskBoxLightResponseToJSON,
    TaskBoxPersonsLightResponseFromJSON,
    TaskBoxPersonsLightResponseToJSON,
    TransportStopFromJSON,
    TransportStopToJSON,
    UpdateAddressPersonResponseFromJSON,
    UpdateAddressPersonResponseToJSON,
    UpdateDoctorSlugFromJSON,
    UpdateDoctorSlugToJSON,
    UpdateDoctorTitleRequestFromJSON,
    UpdateDoctorTitleRequestToJSON,
    UpdateEmailPwrRequestFromJSON,
    UpdateEmailPwrRequestToJSON,
    UpdateEmailPwrResponseFromJSON,
    UpdateEmailPwrResponseToJSON,
    UpdatePersonPermissionRequestFromJSON,
    UpdatePersonPermissionRequestToJSON,
    UpdatePhonePwrRequestFromJSON,
    UpdatePhonePwrRequestToJSON,
    UpdatePhonePwrResponseFromJSON,
    UpdatePhonePwrResponseToJSON,
    UpdateTaskboxPermissionRequestFromJSON,
    UpdateTaskboxPermissionRequestToJSON,
} from '../models/index';

export interface AddFinancialChannelRequest {
    personId: string;
    financialGroupId: number;
    addOrUpdateFinancialChannelRequest: AddOrUpdateFinancialChannelRequest;
}

export interface AddFinancialGroupRequest {
    personId: string;
    addOrUpdateFinancialGroupRequest: AddOrUpdateFinancialGroupRequest;
}

export interface AddTaskBoxRequest {
    personId: string;
    addOrUpdateTaskBoxRequest: AddOrUpdateTaskBoxRequest;
}

export interface CreateDoctorInformationRequest {
    doctorId: string;
    doctorInformation: DoctorInformation;
}

export interface CreateParkingRequest {
    doctorId: string;
    createAvailableParking: CreateAvailableParking;
}

export interface CreatePersonWithRoleAddressRequest {
    personId: string;
    isPatient?: boolean;
    addressPersonRequest?: AddressPersonRequest;
}

export interface CreateTransportStopRequest {
    doctorId: string;
    createTransportStop: CreateTransportStop;
}

export interface DeleteDoctorParkingRequest {
    doctorId: string;
    parkingId: string;
}

export interface DeleteDoctorTransportStopRequest {
    doctorId: string;
    transportId: string;
}

export interface DeletePersonWithRoleAddressRequest {
    personId: string;
    personAddressId: string;
    isPatient?: boolean;
}

export interface DeletePersonWithRoleEmailRequest {
    personId: string;
    emailId: string;
    isPatient?: boolean;
}

export interface DeletePersonWithRolePhoneRequest {
    personId: string;
    phoneId: string;
    isPatient?: boolean;
}

export interface FindAppointmentsByPersonRequest {
    personId: string;
    instituteId: string;
    limit: number;
    start: number;
    minDate?: string;
    maxDate?: string;
}

export interface FindFinancialGroupsForPersonRequest {
    personId: string;
    filterByActive?: boolean;
}

export interface FindInstitutePreferenceByPersonRequest {
    personId: string;
    instituteId: string;
}

export interface FindPersonWithRoleByIdRequest {
    personId: string;
}

export interface FindPersonsByTaskBoxRequest {
    instituteId: string;
    taskboxId: string;
}

export interface FindTaskBoxByPersonRequest {
    personId: string;
}

export interface GetDoctorRequest {
    doctorId: string;
    instituteUuid: string;
    fetchFullInformation?: boolean;
}

export interface GetDoctorSlugRequest {
    doctorId: string;
}

export interface GetFinancialChannelsByFinancialGroupRequest {
    personId: string;
    financialGroupId: number;
}

export interface GetFinancialGroupByIdRequest {
    personId: string;
    financialGroupId: number;
    instituteId: string;
}

export interface GetParkingLotsRequest {
    doctorId: string;
}

export interface GetPlanningByPersonRequest {
    personId: string;
    instituteId?: string;
    periodStart?: string;
    periodEnd?: string;
    appointmentType?: string;
}

export interface GetPlanningGeneralSettingsByPersonRequest {
    personId: string;
    instituteId: string;
    periodStart?: string;
    periodEnd?: string;
}

export interface GetTransportStopsRequest {
    doctorId: string;
}

export interface UpdateActiveFinancialChannelRequest {
    personId: string;
    financialGroupId: number;
    financialChannelId: number;
}

export interface UpdateDoctorInformationRequest {
    doctorId: string;
    doctorInformation: DoctorInformation;
}

export interface UpdateDoctorSlugRequest {
    doctorId: string;
    updateDoctorSlug: UpdateDoctorSlug;
}

export interface UpdateDoctorTitleOperationRequest {
    personId: string;
    updateDoctorTitleRequest: UpdateDoctorTitleRequest;
}

export interface UpdateFinancialChannelRequest {
    personId: string;
    financialGroupId: number;
    financialChannelId: number;
    addOrUpdateFinancialChannelRequest: AddOrUpdateFinancialChannelRequest;
}

export interface UpdateFinancialGroupRequest {
    personId: string;
    financialGroupId: number;
    addOrUpdateFinancialGroupRequest: AddOrUpdateFinancialGroupRequest;
}

export interface UpdateInstitutePreferenceByPersonRequest {
    personId: string;
    instituteId: string;
    institutePreferencesRequest: InstitutePreferencesRequest;
}

export interface UpdateParkingRequest {
    doctorId: string;
    parkingId: string;
    createAvailableParking: CreateAvailableParking;
}

export interface UpdatePersonPermissionByFinancialGroupRequest {
    personId: string;
    financialGroupId: number;
    updatePersonPermissionRequest: UpdatePersonPermissionRequest;
}

export interface UpdatePersonWithRoleAddressRequest {
    personId: string;
    personAddressId: string;
    addressPersonRequest?: AddressPersonRequest;
}

export interface UpdatePersonWithRoleEmailRequest {
    personId: string;
    emailId: string;
    updateEmailPwrRequest: UpdateEmailPwrRequest;
}

export interface UpdatePersonWithRolePhoneRequest {
    personId: string;
    phoneId: string;
    updatePhonePwrRequest: UpdatePhonePwrRequest;
}

export interface UpdateTaskBoxRequest {
    personId: string;
    addOrUpdateTaskBoxRequest: AddOrUpdateTaskBoxRequest;
}

export interface UpdateTaskboxPermissionOperationRequest {
    instituteId: string;
    taskboxId: string;
    personId: string;
    updateTaskboxPermissionRequest: UpdateTaskboxPermissionRequest;
}

export interface UpdateTransportStopRequest {
    doctorId: string;
    transportId: string;
    createTransportStop: CreateTransportStop;
}

/**
 * 
 */
export class PersonApi extends runtime.BaseAPI {

    /**
     * Add a financial channel in a financial_group
     */
    async addFinancialChannelRaw(requestParameters: AddFinancialChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialChannelResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling addFinancialChannel().'
            );
        }

        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling addFinancialChannel().'
            );
        }

        if (requestParameters['addOrUpdateFinancialChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'addOrUpdateFinancialChannelRequest',
                'Required parameter "addOrUpdateFinancialChannelRequest" was null or undefined when calling addFinancialChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group/{financial_group_id}/financial_channel`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateFinancialChannelRequestToJSON(requestParameters['addOrUpdateFinancialChannelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialChannelResponseFromJSON(jsonValue));
    }

    /**
     * Add a financial channel in a financial_group
     */
    async addFinancialChannel(requestParameters: AddFinancialChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialChannelResponse> {
        const response = await this.addFinancialChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a financial_group for a person
     */
    async addFinancialGroupRaw(requestParameters: AddFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialGroupResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling addFinancialGroup().'
            );
        }

        if (requestParameters['addOrUpdateFinancialGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'addOrUpdateFinancialGroupRequest',
                'Required parameter "addOrUpdateFinancialGroupRequest" was null or undefined when calling addFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateFinancialGroupRequestToJSON(requestParameters['addOrUpdateFinancialGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialGroupResponseFromJSON(jsonValue));
    }

    /**
     * Add a financial_group for a person
     */
    async addFinancialGroup(requestParameters: AddFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialGroupResponse> {
        const response = await this.addFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a task_box for a person
     */
    async addTaskBoxRaw(requestParameters: AddTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskBoxLightResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling addTaskBox().'
            );
        }

        if (requestParameters['addOrUpdateTaskBoxRequest'] == null) {
            throw new runtime.RequiredError(
                'addOrUpdateTaskBoxRequest',
                'Required parameter "addOrUpdateTaskBoxRequest" was null or undefined when calling addTaskBox().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/task_box`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateTaskBoxRequestToJSON(requestParameters['addOrUpdateTaskBoxRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskBoxLightResponseFromJSON(jsonValue));
    }

    /**
     * Add a task_box for a person
     */
    async addTaskBox(requestParameters: AddTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskBoxLightResponse> {
        const response = await this.addTaskBoxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add doctor information
     */
    async createDoctorInformationRaw(requestParameters: CreateDoctorInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorInformation>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling createDoctorInformation().'
            );
        }

        if (requestParameters['doctorInformation'] == null) {
            throw new runtime.RequiredError(
                'doctorInformation',
                'Required parameter "doctorInformation" was null or undefined when calling createDoctorInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/information`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DoctorInformationToJSON(requestParameters['doctorInformation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorInformationFromJSON(jsonValue));
    }

    /**
     * Add doctor information
     */
    async createDoctorInformation(requestParameters: CreateDoctorInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorInformation> {
        const response = await this.createDoctorInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add doctor parking
     */
    async createParkingRaw(requestParameters: CreateParkingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParkingAvailable>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling createParking().'
            );
        }

        if (requestParameters['createAvailableParking'] == null) {
            throw new runtime.RequiredError(
                'createAvailableParking',
                'Required parameter "createAvailableParking" was null or undefined when calling createParking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/parking`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAvailableParkingToJSON(requestParameters['createAvailableParking']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParkingAvailableFromJSON(jsonValue));
    }

    /**
     * Add doctor parking
     */
    async createParking(requestParameters: CreateParkingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParkingAvailable> {
        const response = await this.createParkingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create address
     */
    async createPersonWithRoleAddressRaw(requestParameters: CreatePersonWithRoleAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateAddressPersonResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling createPersonWithRoleAddress().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isPatient'] != null) {
            queryParameters['isPatient'] = requestParameters['isPatient'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/addresses`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddressPersonRequestToJSON(requestParameters['addressPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateAddressPersonResponseFromJSON(jsonValue));
    }

    /**
     * Create address
     */
    async createPersonWithRoleAddress(requestParameters: CreatePersonWithRoleAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateAddressPersonResponse> {
        const response = await this.createPersonWithRoleAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add doctor transport stop
     */
    async createTransportStopRaw(requestParameters: CreateTransportStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransportStop>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling createTransportStop().'
            );
        }

        if (requestParameters['createTransportStop'] == null) {
            throw new runtime.RequiredError(
                'createTransportStop',
                'Required parameter "createTransportStop" was null or undefined when calling createTransportStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/transport`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTransportStopToJSON(requestParameters['createTransportStop']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransportStopFromJSON(jsonValue));
    }

    /**
     * Add doctor transport stop
     */
    async createTransportStop(requestParameters: CreateTransportStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransportStop> {
        const response = await this.createTransportStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a doctor parking
     */
    async deleteDoctorParkingRaw(requestParameters: DeleteDoctorParkingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling deleteDoctorParking().'
            );
        }

        if (requestParameters['parkingId'] == null) {
            throw new runtime.RequiredError(
                'parkingId',
                'Required parameter "parkingId" was null or undefined when calling deleteDoctorParking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/parking/{parking_id}`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))).replace(`{${"parking_id"}}`, encodeURIComponent(String(requestParameters['parkingId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a doctor parking
     */
    async deleteDoctorParking(requestParameters: DeleteDoctorParkingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDoctorParkingRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a doctor transport stop
     */
    async deleteDoctorTransportStopRaw(requestParameters: DeleteDoctorTransportStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling deleteDoctorTransportStop().'
            );
        }

        if (requestParameters['transportId'] == null) {
            throw new runtime.RequiredError(
                'transportId',
                'Required parameter "transportId" was null or undefined when calling deleteDoctorTransportStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/transport/{transport_id}`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))).replace(`{${"transport_id"}}`, encodeURIComponent(String(requestParameters['transportId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a doctor transport stop
     */
    async deleteDoctorTransportStop(requestParameters: DeleteDoctorTransportStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDoctorTransportStopRaw(requestParameters, initOverrides);
    }

    /**
     * Delete person address
     */
    async deletePersonWithRoleAddressRaw(requestParameters: DeletePersonWithRoleAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling deletePersonWithRoleAddress().'
            );
        }

        if (requestParameters['personAddressId'] == null) {
            throw new runtime.RequiredError(
                'personAddressId',
                'Required parameter "personAddressId" was null or undefined when calling deletePersonWithRoleAddress().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isPatient'] != null) {
            queryParameters['isPatient'] = requestParameters['isPatient'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/addresses/{person_address_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"person_address_id"}}`, encodeURIComponent(String(requestParameters['personAddressId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete person address
     */
    async deletePersonWithRoleAddress(requestParameters: DeletePersonWithRoleAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePersonWithRoleAddressRaw(requestParameters, initOverrides);
    }

    /**
     * Delete person email
     */
    async deletePersonWithRoleEmailRaw(requestParameters: DeletePersonWithRoleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling deletePersonWithRoleEmail().'
            );
        }

        if (requestParameters['emailId'] == null) {
            throw new runtime.RequiredError(
                'emailId',
                'Required parameter "emailId" was null or undefined when calling deletePersonWithRoleEmail().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isPatient'] != null) {
            queryParameters['isPatient'] = requestParameters['isPatient'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/emails/{email_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"email_id"}}`, encodeURIComponent(String(requestParameters['emailId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete person email
     */
    async deletePersonWithRoleEmail(requestParameters: DeletePersonWithRoleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePersonWithRoleEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Delete person phone
     */
    async deletePersonWithRolePhoneRaw(requestParameters: DeletePersonWithRolePhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling deletePersonWithRolePhone().'
            );
        }

        if (requestParameters['phoneId'] == null) {
            throw new runtime.RequiredError(
                'phoneId',
                'Required parameter "phoneId" was null or undefined when calling deletePersonWithRolePhone().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isPatient'] != null) {
            queryParameters['isPatient'] = requestParameters['isPatient'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/phones/{phone_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"phone_id"}}`, encodeURIComponent(String(requestParameters['phoneId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete person phone
     */
    async deletePersonWithRolePhone(requestParameters: DeletePersonWithRolePhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePersonWithRolePhoneRaw(requestParameters, initOverrides);
    }

    /**
     * Find appointments for a user in an institute
     */
    async findAppointmentsByPersonRaw(requestParameters: FindAppointmentsByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedUserAppointmentsResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling findAppointmentsByPerson().'
            );
        }

        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findAppointmentsByPerson().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling findAppointmentsByPerson().'
            );
        }

        if (requestParameters['start'] == null) {
            throw new runtime.RequiredError(
                'start',
                'Required parameter "start" was null or undefined when calling findAppointmentsByPerson().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instituteId'] != null) {
            queryParameters['instituteId'] = requestParameters['instituteId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['start'] != null) {
            queryParameters['start'] = requestParameters['start'];
        }

        if (requestParameters['minDate'] != null) {
            queryParameters['minDate'] = requestParameters['minDate'];
        }

        if (requestParameters['maxDate'] != null) {
            queryParameters['maxDate'] = requestParameters['maxDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/appointments`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedUserAppointmentsResponseFromJSON(jsonValue));
    }

    /**
     * Find appointments for a user in an institute
     */
    async findAppointmentsByPerson(requestParameters: FindAppointmentsByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedUserAppointmentsResponse> {
        const response = await this.findAppointmentsByPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all financial_group by person
     */
    async findFinancialGroupsForPersonRaw(requestParameters: FindFinancialGroupsForPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialGroupLightResponse>>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling findFinancialGroupsForPerson().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filterByActive'] != null) {
            queryParameters['filterByActive'] = requestParameters['filterByActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialGroupLightResponseFromJSON));
    }

    /**
     * Find all financial_group by person
     */
    async findFinancialGroupsForPerson(requestParameters: FindFinancialGroupsForPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialGroupLightResponse>> {
        const response = await this.findFinancialGroupsForPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all institute preferences by person
     */
    async findInstitutePreferenceByPersonRaw(requestParameters: FindInstitutePreferenceByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InstitutePreferencesResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling findInstitutePreferenceByPerson().'
            );
        }

        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findInstitutePreferenceByPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/institute/{institute_id}/preferences`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InstitutePreferencesResponseFromJSON(jsonValue));
    }

    /**
     * Find all institute preferences by person
     */
    async findInstitutePreferenceByPerson(requestParameters: FindInstitutePreferenceByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InstitutePreferencesResponse> {
        const response = await this.findInstitutePreferenceByPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a person with role by id
     */
    async findPersonWithRoleByIdRaw(requestParameters: FindPersonWithRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonWithRoleResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling findPersonWithRoleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonWithRoleResponseFromJSON(jsonValue));
    }

    /**
     * Find a person with role by id
     */
    async findPersonWithRoleById(requestParameters: FindPersonWithRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonWithRoleResponse> {
        const response = await this.findPersonWithRoleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all doctor attached to a task_box
     */
    async findPersonsByTaskBoxRaw(requestParameters: FindPersonsByTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskBoxPersonsLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling findPersonsByTaskBox().'
            );
        }

        if (requestParameters['taskboxId'] == null) {
            throw new runtime.RequiredError(
                'taskboxId',
                'Required parameter "taskboxId" was null or undefined when calling findPersonsByTaskBox().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/settings/institute/{institute_id}/task_box/{taskbox_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"taskbox_id"}}`, encodeURIComponent(String(requestParameters['taskboxId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskBoxPersonsLightResponseFromJSON));
    }

    /**
     * Find all doctor attached to a task_box
     */
    async findPersonsByTaskBox(requestParameters: FindPersonsByTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaskBoxPersonsLightResponse>> {
        const response = await this.findPersonsByTaskBoxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all task_box by person
     */
    async findTaskBoxByPersonRaw(requestParameters: FindTaskBoxByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskBoxLightResponse>>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling findTaskBoxByPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/task_box`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskBoxLightResponseFromJSON));
    }

    /**
     * Find all task_box by person
     */
    async findTaskBoxByPerson(requestParameters: FindTaskBoxByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaskBoxLightResponse>> {
        const response = await this.findTaskBoxByPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get health pro by id
     */
    async getDoctorRaw(requestParameters: GetDoctorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthPro>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getDoctor().'
            );
        }

        if (requestParameters['instituteUuid'] == null) {
            throw new runtime.RequiredError(
                'instituteUuid',
                'Required parameter "instituteUuid" was null or undefined when calling getDoctor().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fetchFullInformation'] != null) {
            queryParameters['fetchFullInformation'] = requestParameters['fetchFullInformation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/institute/{institute_uuid}`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))).replace(`{${"institute_uuid"}}`, encodeURIComponent(String(requestParameters['instituteUuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthProFromJSON(jsonValue));
    }

    /**
     * Get health pro by id
     */
    async getDoctor(requestParameters: GetDoctorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthPro> {
        const response = await this.getDoctorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a doctor\'s slug
     */
    async getDoctorSlugRaw(requestParameters: GetDoctorSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorSlug>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getDoctorSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/slug`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorSlugFromJSON(jsonValue));
    }

    /**
     * Get a doctor\'s slug
     */
    async getDoctorSlug(requestParameters: GetDoctorSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorSlug> {
        const response = await this.getDoctorSlugRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get financial channel list for a financial_group
     */
    async getFinancialChannelsByFinancialGroupRaw(requestParameters: GetFinancialChannelsByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FinancialChannelLightResponse>>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getFinancialChannelsByFinancialGroup().'
            );
        }

        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getFinancialChannelsByFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group/{financial_group_id}/financial_channel`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FinancialChannelLightResponseFromJSON));
    }

    /**
     * Get financial channel list for a financial_group
     */
    async getFinancialChannelsByFinancialGroup(requestParameters: GetFinancialChannelsByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FinancialChannelLightResponse>> {
        const response = await this.getFinancialChannelsByFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detail of financial_group
     */
    async getFinancialGroupByIdRaw(requestParameters: GetFinancialGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialGroupResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getFinancialGroupById().'
            );
        }

        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling getFinancialGroupById().'
            );
        }

        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getFinancialGroupById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group/{financial_group_id}/institute/{institute_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))).replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialGroupResponseFromJSON(jsonValue));
    }

    /**
     * Get detail of financial_group
     */
    async getFinancialGroupById(requestParameters: GetFinancialGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialGroupResponse> {
        const response = await this.getFinancialGroupByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get doctor parking lots
     */
    async getParkingLotsRaw(requestParameters: GetParkingLotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParkingAvailable>>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getParkingLots().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/parking`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParkingAvailableFromJSON));
    }

    /**
     * Get doctor parking lots
     */
    async getParkingLots(requestParameters: GetParkingLotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParkingAvailable>> {
        const response = await this.getParkingLotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get planning by person, institute and period
     */
    async getPlanningByPersonRaw(requestParameters: GetPlanningByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanningByPeriodResponse>>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPlanningByPerson().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instituteId'] != null) {
            queryParameters['institute_id'] = requestParameters['instituteId'];
        }

        if (requestParameters['periodStart'] != null) {
            queryParameters['periodStart'] = requestParameters['periodStart'];
        }

        if (requestParameters['periodEnd'] != null) {
            queryParameters['periodEnd'] = requestParameters['periodEnd'];
        }

        if (requestParameters['appointmentType'] != null) {
            queryParameters['appointmentType'] = requestParameters['appointmentType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/planning`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlanningByPeriodResponseFromJSON));
    }

    /**
     * Get planning by person, institute and period
     */
    async getPlanningByPerson(requestParameters: GetPlanningByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanningByPeriodResponse>> {
        const response = await this.getPlanningByPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get general setting of planning by person, institute and period
     */
    async getPlanningGeneralSettingsByPersonRaw(requestParameters: GetPlanningGeneralSettingsByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanningGeneralSettingsResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getPlanningGeneralSettingsByPerson().'
            );
        }

        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getPlanningGeneralSettingsByPerson().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instituteId'] != null) {
            queryParameters['institute_id'] = requestParameters['instituteId'];
        }

        if (requestParameters['periodStart'] != null) {
            queryParameters['periodStart'] = requestParameters['periodStart'];
        }

        if (requestParameters['periodEnd'] != null) {
            queryParameters['periodEnd'] = requestParameters['periodEnd'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/planning/general-setting`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanningGeneralSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Get general setting of planning by person, institute and period
     */
    async getPlanningGeneralSettingsByPerson(requestParameters: GetPlanningGeneralSettingsByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanningGeneralSettingsResponse> {
        const response = await this.getPlanningGeneralSettingsByPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get doctor transport stops
     */
    async getTransportStopsRaw(requestParameters: GetTransportStopsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TransportStop>>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getTransportStops().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/transport`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TransportStopFromJSON));
    }

    /**
     * Get doctor transport stops
     */
    async getTransportStops(requestParameters: GetTransportStopsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TransportStop>> {
        const response = await this.getTransportStopsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update active value of financial channel in a financial_group
     */
    async updateActiveFinancialChannelRaw(requestParameters: UpdateActiveFinancialChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialChannelResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateActiveFinancialChannel().'
            );
        }

        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling updateActiveFinancialChannel().'
            );
        }

        if (requestParameters['financialChannelId'] == null) {
            throw new runtime.RequiredError(
                'financialChannelId',
                'Required parameter "financialChannelId" was null or undefined when calling updateActiveFinancialChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group/{financial_group_id}/financial_channel/{financial_channel_id}/update_active`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))).replace(`{${"financial_channel_id"}}`, encodeURIComponent(String(requestParameters['financialChannelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialChannelResponseFromJSON(jsonValue));
    }

    /**
     * Update active value of financial channel in a financial_group
     */
    async updateActiveFinancialChannel(requestParameters: UpdateActiveFinancialChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialChannelResponse> {
        const response = await this.updateActiveFinancialChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update doctor information
     */
    async updateDoctorInformationRaw(requestParameters: UpdateDoctorInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DoctorInformation>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling updateDoctorInformation().'
            );
        }

        if (requestParameters['doctorInformation'] == null) {
            throw new runtime.RequiredError(
                'doctorInformation',
                'Required parameter "doctorInformation" was null or undefined when calling updateDoctorInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/information`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DoctorInformationToJSON(requestParameters['doctorInformation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DoctorInformationFromJSON(jsonValue));
    }

    /**
     * Update doctor information
     */
    async updateDoctorInformation(requestParameters: UpdateDoctorInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DoctorInformation> {
        const response = await this.updateDoctorInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a doctor\'s slug
     */
    async updateDoctorSlugRaw(requestParameters: UpdateDoctorSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling updateDoctorSlug().'
            );
        }

        if (requestParameters['updateDoctorSlug'] == null) {
            throw new runtime.RequiredError(
                'updateDoctorSlug',
                'Required parameter "updateDoctorSlug" was null or undefined when calling updateDoctorSlug().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/slug`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDoctorSlugToJSON(requestParameters['updateDoctorSlug']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a doctor\'s slug
     */
    async updateDoctorSlug(requestParameters: UpdateDoctorSlugRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDoctorSlugRaw(requestParameters, initOverrides);
    }

    /**
     * Update doctor title
     */
    async updateDoctorTitleRaw(requestParameters: UpdateDoctorTitleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateDoctorTitle().'
            );
        }

        if (requestParameters['updateDoctorTitleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDoctorTitleRequest',
                'Required parameter "updateDoctorTitleRequest" was null or undefined when calling updateDoctorTitle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/title`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDoctorTitleRequestToJSON(requestParameters['updateDoctorTitleRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Update doctor title
     */
    async updateDoctorTitle(requestParameters: UpdateDoctorTitleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updateDoctorTitleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a financial channel in a financial_group
     */
    async updateFinancialChannelRaw(requestParameters: UpdateFinancialChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialChannelResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateFinancialChannel().'
            );
        }

        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling updateFinancialChannel().'
            );
        }

        if (requestParameters['financialChannelId'] == null) {
            throw new runtime.RequiredError(
                'financialChannelId',
                'Required parameter "financialChannelId" was null or undefined when calling updateFinancialChannel().'
            );
        }

        if (requestParameters['addOrUpdateFinancialChannelRequest'] == null) {
            throw new runtime.RequiredError(
                'addOrUpdateFinancialChannelRequest',
                'Required parameter "addOrUpdateFinancialChannelRequest" was null or undefined when calling updateFinancialChannel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group/{financial_group_id}/financial_channel/{financial_channel_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))).replace(`{${"financial_channel_id"}}`, encodeURIComponent(String(requestParameters['financialChannelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateFinancialChannelRequestToJSON(requestParameters['addOrUpdateFinancialChannelRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialChannelResponseFromJSON(jsonValue));
    }

    /**
     * Update a financial channel in a financial_group
     */
    async updateFinancialChannel(requestParameters: UpdateFinancialChannelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialChannelResponse> {
        const response = await this.updateFinancialChannelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update detail of financial_group
     */
    async updateFinancialGroupRaw(requestParameters: UpdateFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialGroupResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateFinancialGroup().'
            );
        }

        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling updateFinancialGroup().'
            );
        }

        if (requestParameters['addOrUpdateFinancialGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'addOrUpdateFinancialGroupRequest',
                'Required parameter "addOrUpdateFinancialGroupRequest" was null or undefined when calling updateFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group/{financial_group_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateFinancialGroupRequestToJSON(requestParameters['addOrUpdateFinancialGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialGroupResponseFromJSON(jsonValue));
    }

    /**
     * Update detail of financial_group
     */
    async updateFinancialGroup(requestParameters: UpdateFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialGroupResponse> {
        const response = await this.updateFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update institute preferences by person
     */
    async updateInstitutePreferenceByPersonRaw(requestParameters: UpdateInstitutePreferenceByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateInstitutePreferenceByPerson().'
            );
        }

        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateInstitutePreferenceByPerson().'
            );
        }

        if (requestParameters['institutePreferencesRequest'] == null) {
            throw new runtime.RequiredError(
                'institutePreferencesRequest',
                'Required parameter "institutePreferencesRequest" was null or undefined when calling updateInstitutePreferenceByPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/institute/{institute_id}/preferences`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InstitutePreferencesRequestToJSON(requestParameters['institutePreferencesRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update institute preferences by person
     */
    async updateInstitutePreferenceByPerson(requestParameters: UpdateInstitutePreferenceByPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateInstitutePreferenceByPersonRaw(requestParameters, initOverrides);
    }

    /**
     * Update doctor parking
     */
    async updateParkingRaw(requestParameters: UpdateParkingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ParkingAvailable>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling updateParking().'
            );
        }

        if (requestParameters['parkingId'] == null) {
            throw new runtime.RequiredError(
                'parkingId',
                'Required parameter "parkingId" was null or undefined when calling updateParking().'
            );
        }

        if (requestParameters['createAvailableParking'] == null) {
            throw new runtime.RequiredError(
                'createAvailableParking',
                'Required parameter "createAvailableParking" was null or undefined when calling updateParking().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/parking/{parking_id}`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))).replace(`{${"parking_id"}}`, encodeURIComponent(String(requestParameters['parkingId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAvailableParkingToJSON(requestParameters['createAvailableParking']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ParkingAvailableFromJSON(jsonValue));
    }

    /**
     * Update doctor parking
     */
    async updateParking(requestParameters: UpdateParkingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ParkingAvailable> {
        const response = await this.updateParkingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the person access permission of financial group
     */
    async updatePersonPermissionByFinancialGroupRaw(requestParameters: UpdatePersonPermissionByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialGroupResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updatePersonPermissionByFinancialGroup().'
            );
        }

        if (requestParameters['financialGroupId'] == null) {
            throw new runtime.RequiredError(
                'financialGroupId',
                'Required parameter "financialGroupId" was null or undefined when calling updatePersonPermissionByFinancialGroup().'
            );
        }

        if (requestParameters['updatePersonPermissionRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePersonPermissionRequest',
                'Required parameter "updatePersonPermissionRequest" was null or undefined when calling updatePersonPermissionByFinancialGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/financial_group/{financial_group_id}/permission`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"financial_group_id"}}`, encodeURIComponent(String(requestParameters['financialGroupId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePersonPermissionRequestToJSON(requestParameters['updatePersonPermissionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialGroupResponseFromJSON(jsonValue));
    }

    /**
     * Update the person access permission of financial group
     */
    async updatePersonPermissionByFinancialGroup(requestParameters: UpdatePersonPermissionByFinancialGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialGroupResponse> {
        const response = await this.updatePersonPermissionByFinancialGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update address
     */
    async updatePersonWithRoleAddressRaw(requestParameters: UpdatePersonWithRoleAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateAddressPersonResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updatePersonWithRoleAddress().'
            );
        }

        if (requestParameters['personAddressId'] == null) {
            throw new runtime.RequiredError(
                'personAddressId',
                'Required parameter "personAddressId" was null or undefined when calling updatePersonWithRoleAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/addresses/{person_address_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"person_address_id"}}`, encodeURIComponent(String(requestParameters['personAddressId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddressPersonRequestToJSON(requestParameters['addressPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateAddressPersonResponseFromJSON(jsonValue));
    }

    /**
     * Update address
     */
    async updatePersonWithRoleAddress(requestParameters: UpdatePersonWithRoleAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateAddressPersonResponse> {
        const response = await this.updatePersonWithRoleAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update email
     */
    async updatePersonWithRoleEmailRaw(requestParameters: UpdatePersonWithRoleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateEmailPwrResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updatePersonWithRoleEmail().'
            );
        }

        if (requestParameters['emailId'] == null) {
            throw new runtime.RequiredError(
                'emailId',
                'Required parameter "emailId" was null or undefined when calling updatePersonWithRoleEmail().'
            );
        }

        if (requestParameters['updateEmailPwrRequest'] == null) {
            throw new runtime.RequiredError(
                'updateEmailPwrRequest',
                'Required parameter "updateEmailPwrRequest" was null or undefined when calling updatePersonWithRoleEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/emails/{email_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"email_id"}}`, encodeURIComponent(String(requestParameters['emailId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEmailPwrRequestToJSON(requestParameters['updateEmailPwrRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateEmailPwrResponseFromJSON(jsonValue));
    }

    /**
     * Update email
     */
    async updatePersonWithRoleEmail(requestParameters: UpdatePersonWithRoleEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateEmailPwrResponse> {
        const response = await this.updatePersonWithRoleEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update phone
     */
    async updatePersonWithRolePhoneRaw(requestParameters: UpdatePersonWithRolePhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePhonePwrResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updatePersonWithRolePhone().'
            );
        }

        if (requestParameters['phoneId'] == null) {
            throw new runtime.RequiredError(
                'phoneId',
                'Required parameter "phoneId" was null or undefined when calling updatePersonWithRolePhone().'
            );
        }

        if (requestParameters['updatePhonePwrRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePhonePwrRequest',
                'Required parameter "updatePhonePwrRequest" was null or undefined when calling updatePersonWithRolePhone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/phones/{phone_id}`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))).replace(`{${"phone_id"}}`, encodeURIComponent(String(requestParameters['phoneId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePhonePwrRequestToJSON(requestParameters['updatePhonePwrRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePhonePwrResponseFromJSON(jsonValue));
    }

    /**
     * Update phone
     */
    async updatePersonWithRolePhone(requestParameters: UpdatePersonWithRolePhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePhonePwrResponse> {
        const response = await this.updatePersonWithRolePhoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a task_box for a person
     */
    async updateTaskBoxRaw(requestParameters: UpdateTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskBoxLightResponse>> {
        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateTaskBox().'
            );
        }

        if (requestParameters['addOrUpdateTaskBoxRequest'] == null) {
            throw new runtime.RequiredError(
                'addOrUpdateTaskBoxRequest',
                'Required parameter "addOrUpdateTaskBoxRequest" was null or undefined when calling updateTaskBox().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/{person_id}/settings/task_box`.replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateTaskBoxRequestToJSON(requestParameters['addOrUpdateTaskBoxRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TaskBoxLightResponseFromJSON(jsonValue));
    }

    /**
     * Update a task_box for a person
     */
    async updateTaskBox(requestParameters: UpdateTaskBoxRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskBoxLightResponse> {
        const response = await this.updateTaskBoxRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an taskbox access at a medical person
     */
    async updateTaskboxPermissionRaw(requestParameters: UpdateTaskboxPermissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskBoxPersonsLightResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateTaskboxPermission().'
            );
        }

        if (requestParameters['taskboxId'] == null) {
            throw new runtime.RequiredError(
                'taskboxId',
                'Required parameter "taskboxId" was null or undefined when calling updateTaskboxPermission().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling updateTaskboxPermission().'
            );
        }

        if (requestParameters['updateTaskboxPermissionRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTaskboxPermissionRequest',
                'Required parameter "updateTaskboxPermissionRequest" was null or undefined when calling updateTaskboxPermission().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['personId'] != null) {
            queryParameters['person_id'] = requestParameters['personId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/persons/settings/institute/{institute_id}/task_box/{taskbox_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"taskbox_id"}}`, encodeURIComponent(String(requestParameters['taskboxId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskboxPermissionRequestToJSON(requestParameters['updateTaskboxPermissionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TaskBoxPersonsLightResponseFromJSON));
    }

    /**
     * Update an taskbox access at a medical person
     */
    async updateTaskboxPermission(requestParameters: UpdateTaskboxPermissionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaskBoxPersonsLightResponse>> {
        const response = await this.updateTaskboxPermissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update doctor transport stop
     */
    async updateTransportStopRaw(requestParameters: UpdateTransportStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransportStop>> {
        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling updateTransportStop().'
            );
        }

        if (requestParameters['transportId'] == null) {
            throw new runtime.RequiredError(
                'transportId',
                'Required parameter "transportId" was null or undefined when calling updateTransportStop().'
            );
        }

        if (requestParameters['createTransportStop'] == null) {
            throw new runtime.RequiredError(
                'createTransportStop',
                'Required parameter "createTransportStop" was null or undefined when calling updateTransportStop().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/doctors/{doctor_id}/transport/{transport_id}`.replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))).replace(`{${"transport_id"}}`, encodeURIComponent(String(requestParameters['transportId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTransportStopToJSON(requestParameters['createTransportStop']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransportStopFromJSON(jsonValue));
    }

    /**
     * Update doctor transport stop
     */
    async updateTransportStop(requestParameters: UpdateTransportStopRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransportStop> {
        const response = await this.updateTransportStopRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
